/**
 * Legacy DiscountsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.discountsApi`) keep resolving.
 *
 * The actual DiscountsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/discounts/discounts-api.service.ts
 */
angular.module("acme.common.service.discountsApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
